export default __webpack_public_path__ + "static/media/logo-green.ead91276.svg";